import { useEffect, useState } from 'react'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import { TryCatch } from '../../../../utils/general'
import {
  addDocument,
  deleteSubDocument,
  getDocument,
  getSubDocument,
  getSubDocuments,
  getSubSubDocumentsWithQuery,
  updateSubDocument,
} from '../../../../firebase/firestore'

export const useClientCampaign = () => {
  const {
    user,
    setAlerts,
    dataContext,
    setDataContext, // contexto que guarda dados de lista para a pagina
    infosContext,
    setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    setLoading,
    loading,
  } = useGlobalContext()

  const [modalAdd, setModalAdd] = useState(false)
  const [search, setSearch] = useState('')
  const clientId = user.client.id
  const [openMsg, setOpenMsg] = useState({})

  function toggle(id) {
    setOpenMsg((prev) => ({ ...prev, [id]: !prev[id] }))
  }

  const getDatas = async () => {
    const getCampaigns = await getSubDocuments('clientes', clientId, 'campaigns')

    const querySends = getCampaigns.map(async (campaign) => {
      const idCamp = campaign.id
      let { status, sendsOk, sendError } = campaign

      if (status !== 'Concluído') {
        const getsends = await getSubSubDocumentsWithQuery(
          'clientes',
          clientId,
          'campaigns',
          idCamp,
          'sends',
          'status',
          '==',
          'ok',
        )
        sendsOk = getsends.length
        const getErrors = await getSubSubDocumentsWithQuery(
          'clientes',
          clientId,
          'campaigns',
          idCamp,
          'sends',
          'status',
          '==',
          'error',
        )
        sendError = getErrors.length
      }

      let success = 'Em Andamento'
      try {
        success = await getDocument('_notifications_all', idCamp)
      } catch (e) {
        success = 'Concluído'
      }

      const newCampaign = { ...campaign, sendsOk, sendError, status: success }

      await updateSubDocument('clientes', clientId, 'campaigns', idCamp, newCampaign)
      return newCampaign
    })

    const campains = await Promise.all(querySends)

    setDataContext({ campaigns: campains })
  }

  const getInfos = async () => {
    if (!infosContext?.n_staff_total) {
      const getEstimateScend = await getSubDocument('configs', 'dadosAxiliares', 'campaigns', 'estimateSend')
      const total = getEstimateScend?.estimate_send || getEstimateScend || 0

      setInfosContext((prev) => ({
        ...prev,
        n_staff_total: total,
      }))
    }
  }

  const deleteCampaigns = async (id) => {
    await deleteSubDocument('clientes', clientId, 'campaigns', id)
    await FetchGetDatas()
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: `Equipe Deletada`,
        msg: `A equipe foi deleta da sua base de dados.`,
      },
    ])
  }

  const AddCampaigns = async (values) => {
    if (!values?.title || !values?.msg) {
      return setAlerts([
        {
          type: 'error',
          title: `Titulo ou mensagem incorreto`,
          msg: `O Titulo ou a mensagem da campanha estão incorretos, revise-os e tente novamente.`,
        },
      ])
    }
    // await addSubDocument('clientes', clientId, 'campaigns', values)
    await addDocument('_notifications_all', values)
    await new Promise((resolve) => setTimeout(resolve, 5000))
    await FetchGetDatas()
    await setModalAdd(false)
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: `Campanha criada com sucesso`,
        msg: `Aguarde a campanha ser envia ao staff, isso pode demorar até 30 minutos.`,
      },
    ])
  }

  const FetchGetDatas = async () => {
    await TryCatch(getDatas, setLoading, setAlerts)
  }

  const HandleDeleteCampaigns = async (id) => {
    await TryCatch(
      () => {
        deleteCampaigns(id)
      },
      setLoading,
      setAlerts,
    )
  }

  const HandleAddCampaigns = async (values) => {
    await TryCatch(
      async () => {
        await AddCampaigns(values)
      },
      setLoading,
      setAlerts,
    )
  }

  const dataFiltered = dataContext?.campaigns || []

  // executa quando carrega a pagina e quando é auterado o getUserList
  useEffect(() => {
    FetchGetDatas()
    getInfos()
  }, [])

  return {
    loading,
    search,
    setSearch,
    dataContext,
    FetchGetDatas,
    HandleDeleteCampaigns,
    HandleAddCampaigns,
    dataFiltered,
    modalAdd,
    setModalAdd,
    toggle,
    openMsg,
    setOpenMsg,
    infosContext,
  }
}
